export default function R_DataFrames() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">R_DataFrames Component</h1>
      <p>This is the R_DataFrames tutorial section.</p>
    </div>
  );
}
